export const services = [
  {
    id: 1,
    title: "Customs Brokerage",
    description:
      "Expert handling of all customs brokerage processes, including Mirsal 2 documentation and compliance across the UAE.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/customs_brokerage_icon.png`,
  },
  {
    id: 2,
    title: "Air & Sea Freight Forwarding",
    description:
      "Seamless freight forwarding through Dubai Airports, Jebel Al Port, Sharjah Port, and Umm Al Quwain Port — ensuring efficient cargo movement, globally.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/air_sea_freight_icon.png`,
  },
  {
    id: 3,
    title: "Import/Export Customs Clearance",
    description:
      "Fast, accurate customs clearance for both imports and exports, reducing delays and ensuring smooth border transitions.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/customs_clearance_icon.png`,
  },
  {
    id: 4,
    title: "Customs Code – New & Renewal",
    description:
      "Quick setup and renewal of your customs code for uninterrupted trade operations, aligned with UAE regulations.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/customs_code_icon.png`,
  },
  {
    id: 5,
    title: "Customs Representative Card – New & Renewal",
    description:
      "We manage the full process for issuing or renewing customs representative cards, keeping your business authorized and compliant.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/customs_representative_card_icon.png`,
  },
  {
    id: 6,
    title: "Goods in Transit / Transshipment",
    description:
      "Reliable facilitation of goods in transit and transshipment through UAE ports, optimizing routing and reducing clearance time.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/goods_transit_icon.png`,
  },
  {
    id: 7,
    title: "Land Transport – UAE & GCC",
    description:
      "Scheduled and on-demand transport from Dubai to Abu Dhabi, Sharjah, and GCC countries — secure and timely deliveries every time.",
    icon: `${process.env.PUBLIC_URL}/assets/icons/land_transport_icon.png`,
  },
];

export const SERVICE_SECTION_ID = 'service-container';

export const SERVICE_BANNER_IMAGE = `${process.env.PUBLIC_URL}/assets/service_banner.jpg`;

export const SERVICE_BANNER_TITLE = 'Our Services';

export const SWIPER_CONFIG = {
  spaceBetween: 32,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
  style: {
    padding: '10px 8px',
  },
};

export const REQUEST_QUOTE_LABEL = 'Request Quote';